import { render, staticRenderFns } from "./ShippersDeclarationComponent.vue?vue&type=template&id=764165d5&scoped=true"
import script from "./ShippersDeclarationComponent.vue?vue&type=script&lang=js"
export * from "./ShippersDeclarationComponent.vue?vue&type=script&lang=js"
import style0 from "./ShippersDeclarationComponent.vue?vue&type=style&index=0&id=764165d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764165d5",
  null
  
)

export default component.exports